import axios from 'axios';

const ScheduleService = {
  async getServices() {
    return axios.get('/api/schedule/services')
  },

  async getCarTypes() {
    return axios.get('/api/schedule/car-types')
  },

  async fetchWidths() {
    const url = '/api/schedule/widths';
    return axios.get(url, {});
  },
  async fetchHeights() {
    const url = '/api/schedule/heights';
    return axios.get(url, {});
  },
  async fetchDiameters() {
    const url = '/api/schedule/diameters';
    return axios.get(url, {});
  },

  async getUserGraph(serviceId, date) {
    const url = this.buildUrlWithGetParams('/api/schedule/user-graph', {
      'serviceId': serviceId,
      'date': date
    });

    return axios.get(url);
  },

  async getRecords(data) {
    const url = this.buildUrlWithGetParams('/api/schedule/record/get_all', data);

    return axios.get(url);
  },

  async getRecord(data) {
    const url = this.buildUrlWithGetParams('/api/schedule/record/get', {
      'userId': data.userId,
      'recordId': data.recordId
    });

    return axios.get(url);
  },

  async saveRecord(data) {
    return axios.post('/api/schedule/record/save', data);
  },

  async getAdminGraph(serviceId, date) {
    const url = this.buildUrlWithGetParams('/api/schedule/admin-graph', {
      'serviceId': serviceId,
      'date': date
    });

    return axios.get(url);
  },

  async deleteRecord(data) {
    const url = this.buildUrlWithGetParams('/api/schedule/record/delete', {
      'recordId': data.recordId
    });
    return axios.delete(url);
  },

  buildUrlWithGetParams(link, params) {
    let paramsString = '';

    for (const param in params) {
      if(params.hasOwnProperty(param)) {
        paramsString += (paramsString === '') ? "?" : "&";
        paramsString += `${param}=${params[param]}`;
      }
    }

    return link + paramsString;
  }
};

export default ScheduleService;